import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  Tooltip,
  Menu,
  IconButton,
  Checkbox,
  FormControl,
  Autocomplete,
  ListSubheader,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate, useParams } from "react-router-dom";
import { CiCirclePlus, CiFilter } from "react-icons/ci";
import SearchBar from "../../SearchBar";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IoIosArrowBack } from "react-icons/io";
import QuillComponent from "../../common/ReactQuill";
import { ExpandMore } from "@mui/icons-material";
import FileUpload from "../../common/FileUpload";
import { fetchEntityById, newFilterEntities, postResource,} from "../../../apis/apiService";
import { toast } from "react-toastify";
import { format } from "date-fns";
import Loader, { BtnLoader } from "../../common/Loader";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { setIssueNameOptions } from "../../../selectSlice";
import {
  useFetchGetAllProjectBasedUserNameListQuery,
  useFetchMilestoneBasedIsuueFilterQuery,
  useFetchMilestoneIssuesQuery,
  useFetchMilestoneModuleQuery,
} from "../../../slice/logdetailSlice";
import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import { CommonAddIssue } from "../../common/Issue/CommonAddIssue";
import { IssueFilterComponent } from "../issues/IssueTab";
import { FilterSummaryBox } from "../../common/FilterSummaryBox";
import CommonDeleteDialog from "../../common/CommonDelete";
import { useTheme } from "../../../ThemeContext";
import IssueBoard from "../issues/IssueBoard";
import { openInNewTab } from "../../../utils/openInNewTab";


const MilestoneIssueFilterComponent = ({ onApply, onClear, onCancel }) => {
  const { id: milestone_id } = useParams();
  ////console.log()("id_data", milestone_id);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const projectNames = useSelector(
    (state) => state.selectOptions.ProjectNameOptions
  );

  const { handleSubmit, control, reset, setValue, formState: { errors } } = useForm({
    defaultValues: {
      issueName: "",
      Reporter: "",
      Assignee: "",
      createdBy: "",
      createdDate: null,
      lastModifiedBy: "",
      startDate: null,
      endDate: null,
      Severity: "",
      Module: "",
      status: "",
    },
  });

  // const reporterOptions = useSelector(
  //   (state) => state.selectOptions?.userNamesByProjects
  // );
  const { data: reporterOptions } =
    useFetchGetAllProjectBasedUserNameListQuery(milestone_id);
  ////console.log()("reporterOptions", reporterOptions);

  const statusOptions = useSelector((state) => state.selectOptions?.StatusOptions);
  const statusNames = statusOptions.find((statusName) => statusName.status_type === "ISSUE");
  const statusList = statusNames?.status_details?.map((statusList) => ({
    id: statusList.status_id,
    status_name: statusList.status_name,
    status_colour: statusList.status_colour,
  }));
  ////console.log()("StatusList: ", statusList);

  const serverityOptions = useSelector((state) => state.selectOptions.SeverityNameOptions);
  const { data: issueNameList } =
    useFetchMilestoneBasedIsuueFilterQuery(milestone_id);

  const fetchAllIssues = async () => {
    try {
      const response = await fetchEntityById("issuesInProjects", milestone_id);
      ////console.log()("issue_name_list_in_selector dispatch :", response.data);
      dispatch(setIssueNameOptions(response.data));
    } 
    catch (error) {
      console.error("Error fetching issues:", error);
    }
  };
  useEffect(() => {
    fetchAllIssues();
  }, []);

  const onSubmit = async (data) => {
    const hasActiveFilter = 
      (data.issueName && data.issueName.length > 0) ||
      data.Reporter ||
      data.Assignee ||
      data.createdBy ||
      data.createdDate ||
      data.lastModifiedBy ||
      data.startDate ||
      data.endDate ||
      data.Severity ||
      data.Module ||
      data.status;

    if (!hasActiveFilter) {
      toast.info("No filter values selected. Select one or more filters to apply");
      return;
    }

    ////console.log()("data_in_onSubmit :", data);
    const requestedData = {
      title: data.issueName, // Assuming you want the first selected title
      added_by: parseInt(data.Reporter, 10) || null, // Ensure numeric ID
      assignee: data.Assignee,
      start_due_date: data.startDate
        ? format(new Date(data.startDate), "yyyy-MM-dd")
        : null,
      end_due_date: data.endDate
        ? format(new Date(data.endDate), "yyyy-MM-dd")
        : null,
      // billing_type: data.billingType || null,
      created_by: parseInt(data.added_by, 10) || null,
      current_status_id: data.status || null,
      created_date: data.createdDate
        ? format(new Date(data.createdDate), "yyyy-MM-dd")
        : null,
      severity_id: data.Severity,
      last_modified_by: data.lastModifiedBy
        ? parseInt(data.lastModifiedBy, 10)
        : null,
      module: data.Module,
    };
    setLoading(true);
    ////console.log()(" data_in_onSubmit requested_data :", requestedData);

    ////console.log()("datass :", data);
    try {
      const response = await newFilterEntities( "milestones/issue/filter", milestone_id, requestedData);
      if (response.data) {
        onApply(response.data);
        toast.success(response.message);
      }

      // onApply(filterIssues);
    } 
    catch (err) {
      const errorMsg = err.message;
      console.error(err);
      toast.error(errorMsg);
    } 
    finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    reset();
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack className=" text-rgba-gray" />
            Filter
          </div>
        </button>

        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red"
          >
            Clear Filter
          </button>
        </div>
      </div>

      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="">
              <div className="row mb-3">
                <div className="col-12">
                  <label htmlFor="issueName" className="form-label">
                    Search by Issues
                  </label>
                  <Controller
                    name="issueName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        multiple
                        id="issueName"
                        options={issueNameList}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.title}
                        value={
                          (value || []).map((title) =>
                            issueNameList?.find((user) => user.title === title)
                          ) || []
                        }
                        onChange={(event, newValue) => {
                          const selectedTitles = newValue.map(
                            (user) => user.title
                          );
                          onChange(selectedTitles);
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.title}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Enter issue name"
                          />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                </div>
              </div>

              <div className="row mb-3 ">
                <div className="col-md-6">
                  <label htmlFor="Reporter" className="form-label">
                    Reporter
                  </label>
                  <Controller
                    control={control}
                    name="Reporter"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          labelId="Reporter"
                          {...field}
                          id="Reporter"
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              reporterOptions?.find(
                                (list) => list.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {reporterOptions?.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="Assignee" className="form-label">
                    Assignee
                  </label>
                  <Controller
                    name="Assignee"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              reporterOptions?.find(
                                (list) => list.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          labelId="Assignee-label"
                          id="Assignee"
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {reporterOptions?.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}

                          {/* Add other options as needed */}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="createdDate" className="form-label">
                    Created Date
                  </label>
                  <Controller
                    name="createdDate"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (!val) return true;
                        const d = dayjs(val);
                        if (!d.isValid()) return "Invalid date";
                        if (d.year() < 1900) return "Invalid date format";
                        return true;
                      }
                    }}
                    render={({ field }) => (
                      <>
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => (
                            <input
                              className="form-control datepic_ip"
                              {...params}
                            />
                          )}
                        />
                        {errors.createdDate && (
                          <span className="errorMsg">
                            {errors.createdDate.message}
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="createdBy" className="form-label">
                    Created By
                  </label>
                  <Controller
                    name="createdBy"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          labelId="createdBy-label"
                          id="createdBy"
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              reporterOptions?.find(
                                (list) => list.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {reporterOptions?.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}

                          {/* Add other options as needed */}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              <div className="row mb-3">
                {/*  */}
                <div className="col-md-6">
                  <label htmlFor="lastModifiedBy" className="form-label ">
                    Last Modified By
                  </label>
                  <Controller
                    control={control}
                    name="lastModifiedBy"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              reporterOptions?.find(
                                (list) => list.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          labelId="lastModifiedBy-label"
                          id="lastModifiedBy"
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {reporterOptions?.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="status" className="form-label">
                    status
                  </label>
                  <Controller
                    name="status"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Controller
                          name="status"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              value={field.value || ""}
                              onChange={(e) => {
                                field.onChange(e.target.value); // Update form state
                                setValue("status", e.target.value); // Optionally set value
                              }}
                              displayEmpty
                              renderValue={(selected) => {
                                const selectedValue = statusList?.find(
                                  (statusName) => statusName.id === selected
                                );
                                return selectedValue ? (
                                  <span
                                    style={{
                                      color: selectedValue.status_colour,
                                    }}
                                  >
                                    {selectedValue.status_name}
                                  </span>
                                ) : (
                                  <span className=" lightText">
                                    Select status
                                  </span>
                                );
                              }}
                              IconComponent={ExpandMoreIcon}
                            >
                              {statusList.map((status, index) => (
                                <MenuItem
                                  key={index}
                                  style={{
                                    color: status.status_colour || "black",
                                  }}
                                  value={status.id}
                                >
                                  {status.status_name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="startDate" className="form-label">
                    Start Date
                  </label>
                  <Controller
                    name="startDate"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (!val) return true;
                        const d = dayjs(val);
                        if (!d.isValid()) return "Invalid date";
                        if (d.year() < 1900) return "Invalid date format";
                        return true;
                      }
                    }}
                    render={({ field }) => (
                      <>
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          className="datepicker_input"
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => (
                            <input
                              className="form-control datepicker_input"
                              {...params}
                            />
                          )}
                        />
                        {errors.startDate && (
                          <span className="errorMsg">
                            {errors.startDate.message}
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="endDate" className="form-label">
                    End Date
                  </label>
                  <Controller
                    name="endDate"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (!val) return true;
                        const d = dayjs(val);
                        if (!d.isValid()) return "Invalid date";
                        if (d.year() < 1900) return "Invalid date format";
                        return true;
                      }
                    }}
                    render={({ field }) => (
                      <>
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => (
                            <input
                              className="form-control datepic_ip"
                              {...params}
                            />
                          )}
                        />
                        {errors.endDate && (
                          <span className="errorMsg">
                            {errors.endDate.message}
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>
              </div>

              <div className="row paddingBtn  mb-3">
                <div className="col-md-6">
                  <label htmlFor="Severity" className="form-label">
                    Severity
                  </label>
                  <Controller
                    name="Severity"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          labelId="Severity-label"
                          id="Severity"
                          displayEmpty
                          renderValue={(selected) => {
                            const selected_value = serverityOptions?.find(
                              (list) => list.severity_id === selected
                            );
                            return selected_value ? (
                              <span
                                style={{
                                  color:
                                    selected_value.severity_colour || "black",
                                }}
                              >
                                {selected_value.severity_name}
                              </span>
                            ) : (
                              <span className="lightText">Select severity</span>
                            );
                          }}
                          // {...control.register("Severity")}
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {serverityOptions.map((list, index) => (
                            <MenuItem
                              key={index}
                              sx={{ color: list.severity_colour }}
                              value={list.severity_id}
                            >
                              {list.severity_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
                {/* <div className="col-md-6">
                  <label htmlFor="Module" className="form-label">
                    Module
                  </label>
                  <Controller
                    control={control}
                    name="Module"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          labelId="Module-label"
                          id="Module"
                          {...field}
                          IconComponent={ExpandMore} // Add the custom icon here
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              // reporterOptions?.find(
                              //   (list) => list.user_id === selected
                              // )?.name
                              <span className="lightText">Module</span>
                            )
                          }
                        >
                          <MenuItem value="Module">Select Type</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div> */}
              </div>

              <div className="d-flex py-3 w-100 align-items-center position-absolute bottom-0 bg-white mt-3">
                <button
                  type="submit"
                  className="me-3 add_btn"
                  disabled={loading}
                >
                  {loading ? "Applying..." : "Apply"}
                </button>
                <button
                  type="button"
                  className="cancel_btn"
                  onClick={(event) => {
                    event.preventDefault();
                    onCancel();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};


const AddMilestoneIssueComponent = ({
  onApply,
  onClear,
  onCancel,
  fetchMilestoneIssues,
}) => {
  const project_id = localStorage.getItem("project_id");
  const { id: milestone_id } = useParams();
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
    register,
    clearErrors,
  } = useForm({
    defaultValues: {
      Assignee: "",
      DueDate: undefined,
      Severity: "",
      issue_name: "",
      Module: "",
      Priority: "",
      uploadedFile: null,
      description: "",
      followers: [],
    },
  });

  // const projectBasedUsers = useSelector(
  //   (state) => state.selectOptions?.userNamesByProjects
  // );
  // const { data: projectBasedUsers } =
    useFetchGetAllProjectBasedUserNameListQuery(project_id);
  ////console.log()("login_user_detail matching========= value :", projectBasedUsers);
  const priorityList = useSelector((state) => state.selectOptions?.PriorityNameOptions);
  const priorityOptions = priorityList.find((list) => list.priority_type === "ISSUE");
  const serverityList = useSelector((state) => state.selectOptions?.SeverityNameOptions);
  ////console.log()("SeverityNameOptions : ", serverityList);

  ////console.log()("PriorityList: ", priorityOptions);
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  // const { name, id: login_user_id } = loginUser;
  ////console.log()("login_user_detail :id", login_user_id, "name :", name);
  const { data: usersInProjects } = useFetchGetAllProjectBasedUserNameListQuery(project_id);
  ////console.log()("users_in_projects usersInProjects project :", usersInProjects);
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const { refetch: milestone_module_refetch } = useFetchMilestoneModuleQuery();
  const addMore = (e) => {
    e.preventDefault();
    handleSubmit((data) => addMoreIssue(data))();
  };

  const addMoreIssue = async (data) => {
    const formData = new FormData();
    // Append form fields
    formData.append("issue_name", data.issue_name);
    formData.append("due_date", data.DueDate ? dayjs(data.DueDate).format("YYYY-MM-DD") : "");
    formData.append("module", data.Module || "");
    formData.append("description", data.description || "");
    formData.append("severity_id", parseInt(data.Severity, 10));
    formData.append("priority_id", parseInt(data.Priority, 10));
    formData.append("assignee", data.Assignee);

    // Append file if uploaded
    if (uploadedFile) {
      uploadedFile.forEach((file) => {
        formData.append("document[]", file);
      });
    }

    // Append followers as array
    data.followers.forEach((follower, index) => {
      formData.append(`followers[${index}]`, follower);
    });

    setLoading(true);
    try {
      ////console.log()("Request Payload:", formData);

      // Send FormData
      const response = await postResource("milestones/issue","add",milestone_id, formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      ////console.log()("API Response:", response);
      if (response) {
        toast.success(response.message || "Issue added successfully!");
        fetchMilestoneIssues();
        milestone_module_refetch();
      }
      // onCancel();
      reset();
      onApply(response);
    } 
    catch (err) {
      console.error(
        "Error during API call:",
        err.response?.data || err.message
      );
    } 
    finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    const formData = new FormData();

    // Append form fields
    formData.append("issue_name", data.issue_name);
    formData.append( "due_date",data.DueDate ? dayjs(data.DueDate).format("YYYY-MM-DD") : "");
    formData.append("module", data.Module || "");
    formData.append("description", data.description || "");
    formData.append("severity_id", parseInt(data.Severity, 10));
    formData.append("priority_id", parseInt(data.Priority, 10));
    formData.append("assignee", data.Assignee);

    // Append file if uploaded
    if (uploadedFile) {
      uploadedFile.forEach((file) => {
        formData.append("document[]", file);
      });
    }

    // Append followers as array
    data.followers.forEach((follower, index) => {
      formData.append(`followers[${index}]`, follower);
    });

    setLoading(true);
    try {
      ////console.log()("Request Payload:", formData);

      // Send FormData
      const response = await postResource(
        "milestones/issue",
        "add",
        milestone_id,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      ////console.log()("API Response:", response);
      if (response) {
        toast.success(response.message || "Issue added successfully!");
        fetchMilestoneIssues();
        milestone_module_refetch();
      }
      onCancel();
      onApply(response);
    } 
    catch (err) {
      console.error(
        "Error during API call:",
        err.response?.data || err.message
      );
    } 
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          {/* <IoIosArrowBack /> */}
          <div className="d-flex  text-rgba-gray align-items-center">
            <IoIosArrowBack className=" text-rgba-gray" />
            Submit Issue
          </div>
        </button>
      </div>

      <div className="bg-white px-4 pt-3 overflow-scroll pb-5">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="issue_name" className="form-label">
                    Issue Name <span className="errorMsg">*</span>
                  </label>
                  <TextField
                    type="text"
                    id="issue_name"
                    placeholder="Enter Issue Name"
                    // className="form-control"
                    sx={{ width: "100%" }}
                    {...register("issue_name", {
                      required: "The issue name field is required",
                    })}
                  />
                  {errors.issue_name && (
                    <p className=" errorMsg">{errors.issue_name.message}</p>
                  )}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="description" className="form-label">
                    Add Description
                  </label>
                  <QuillComponent control={control} name="description" />
                  {/* <ReactQuill/> */}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="Upload File" className="form-label">
                    Upload File
                  </label>
                  <FileUpload onFileChange={(file) => setUploadedFile(file)} />
                </div>
              </div>

              <div className="col-md-12  my-3">
                <label htmlFor="followers" className="form-label">
                  Add Followers
                </label>
                <Controller
                  name="followers"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Autocomplete
                      multiple
                      id="followers"
                      options={usersInProjects}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.name}
                      value={
                        (value || []).map((user_id) =>
                          usersInProjects?.find(
                            (user) => user.user_id === user_id
                          )
                        ) || []
                      }
                      onChange={(event, newValue) => {
                        const selectedTitles = newValue.map(
                          (user) => user.user_id
                        );
                        onChange(selectedTitles);
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li
                          {...props}
                          className="d-flex align-items-center mb-2"
                        >
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          <strong>{option.name}</strong>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Followers" />
                      )}
                      ListboxProps={{
                        style: {
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "8px",
                          paddingLeft: "0",
                        },
                      }}
                    />
                  )}
                />
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="Assignee" className="form-label">
                    Assignee <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    control={control}
                    name="Assignee"
                    render={({ field: { ref, onChange, ...fieldProps } }) => (
                      <FormControl fullWidth>
                        <Select
                          {...fieldProps}
                          inputRef={ref}
                          onChange={(e) => {
                            onChange(e);
                            clearErrors("Assignee");
                          }}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              usersInProjects?.find(
                                (user) => user.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Assignee</span>
                            )
                          }
                          labelId="Assignee-label"
                          id="Assignee"
                          IconComponent={ExpandMore}
                        >
                          {usersInProjects?.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    rules={{ required: "Assignee field is required" }}
                  />
                  {errors.Assignee && (
                    <p className="errorMsg">{errors.Assignee.message}</p>
                  )}
                </div>

                <div className="col-md-6">
                  <label htmlFor="DueDate" className="form-label">
                    Due Date
                  </label>
                  <Controller
                    name="DueDate"
                    control={control}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <input className="form-control" {...params} />
                        )}
                      />
                    )}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="Priority" className="form-label">
                    Priority <span className="errorMsg">*</span>
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="Priority"
                      control={control}
                      rules={{ required: "Priority field is required" }}
                      render={({
                        field: { onChange, value, ref },
                        fieldState: { error },
                      }) => (
                        <>
                          <Select
                            onChange={onChange}
                            inputRef={ref}
                            value={value}
                            displayEmpty
                            renderValue={(selected) => {
                              const selected_value =
                                priorityOptions.priority_details.find(
                                  (list) => list.priority_id === selected
                                );
                              return selected_value ? (
                                <span
                                  style={{
                                    color:
                                      selected_value.priority_colour || "black",
                                  }}
                                >
                                  {selected_value.priority_name}
                                </span>
                              ) : (
                                <span className=" lightText">
                                  Select priority
                                </span>
                              );
                            }}
                            // IconComponent={ExpandMoreIcon}
                          >
                            {priorityOptions?.priority_details.map(
                              (priority) => (
                                <MenuItem
                                  key={priority?.priority_id}
                                  // color={priority?.priority_color}
                                  sx={{
                                    color: priority?.priority_colour || "black",
                                  }}
                                  value={priority?.priority_id}
                                >
                                  {priority?.priority_name}
                                </MenuItem>
                              )
                            )}
                          </Select>
                          {error && (
                            <span className="errorMsg">{error.message}</span>
                          )}
                        </>
                      )}
                    />
                  </FormControl>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="Severity" className="form-label">
                    Severity <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    control={control}
                    name="Severity"
                    render={({ field: { ref, onChange, ...fieldProps } }) => (
                      <FormControl fullWidth>
                        <Select
                          inputRef={ref}
                          {...fieldProps}
                          onChange={(e) => {
                            onChange(e);
                            clearErrors("Severity ");
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            const selected_value = serverityList.find(
                              (list) => list.severity_id === selected
                            );
                            return selected_value ? (
                              <span
                                style={{
                                  color:
                                    selected_value.severity_colour || "black",
                                }}
                              >
                                {selected_value.severity_name}
                              </span>
                            ) : (
                              <span className="lightText">Select severity</span>
                            );
                          }}
                          labelId="Severity-label"
                          id="Severity"
                          IconComponent={ExpandMore}
                        >
                          {serverityList.map((list, index) => (
                            <MenuItem
                              key={index}
                              sx={{ color: list.severity_colour || "black" }}
                              value={list.severity_id}
                            >
                              {list.severity_name}
                            </MenuItem>
                          ))}

                          {/* Add other options */}
                        </Select>
                      </FormControl>
                    )}
                    rules={{ required: "Severity field is required" }}
                  />
                  {errors.Severity && (
                    <span
                      className="errorMsg"
                      ref={(el) => {
                        if (el & errors) {
                          el.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                          });
                        }
                      }}
                    >
                      {errors.Severity.message}
                    </span>
                  )}
                </div>
                
                <div className="col-md-12 my-3">
                  <label htmlFor="Module" className="form-label">
                    Module
                  </label>
                  <TextField
                    type="text"
                    id="Module"
                    sx={{ width: "100%" }}
                    placeholder="Enter Module"
                    {...control.register("Module")}
                  />
                </div>
              </div>

              <div className="bg-white position-absolute bottom-0 py-3 w-100">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="me-3 add_btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <BtnLoader />
                      </>
                    ) : (
                      "Add"
                    )}
                  </button>
                  <button
                    type="button"
                    className="addmore_btn me-3"
                    disabled={loading}
                    onClick={addMore}
                  >
                    Add more
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const MilestoneIssue = () => {
  const { isDarkMode } = useTheme();
  const { reset } = useForm();
  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 100,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
          <IconButton
            onClick={(e) => handleMenuClick(e, params.row)}
            size="small"
            style={{ padding: "10px", marginBottom: "10px" }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </div>
      ),
    },
    { field: "issue_id", 
      headerName: "ID", 
      width: 100 
    },
    {
      field: "title",
      headerName: "Name",
      width: 250,
      renderCell: (params) => {
        const handleClick = () => {
          navigate(`/projects/projectDetail/${params.row.project_id || project_id}/issue/IssueDetail/${params.row.issue_id}`);
        };
        return (
          <Box
            sx={{
              cursor: "pointer",
            }}
            onClick={handleClick}
          >
            {params.row.title}
          </Box>
        );
      },
    },
    {
      field: "module",
      headerName: "Module",
      width: 180,
      renderCell: (params) =>
        params.value ? (
          <Box
            sx={{
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {params.value}
          </Box>
        ) : (
          "-"
        ),
    },
    {
      field: "reporter",
      headerName: "Reporter",
      width: 180,
      renderCell: (params) => params.value || "Unassigned",
    },
    {
      field: "assignee",
      headerName: "Assignee",
      width: 180,
      renderCell: (params) => params.value || "Unassigned",
    },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 180,
      renderCell: (params) =>
        params.value ? (
          <Box
            sx={{
              color: params.row.status_colour || "black",
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {params.value}
          </Box>
        ) : (
          "-"
        ),
    },
    {
      field: "priority_name",
      headerName: "Priority",
      width: 150,
      renderCell: (params) =>
        params.value ? (
          <Box sx={{ color: params.row.priority_colour || "black" }}>
            {params.value}
          </Box>
        ) : (
          "-"
        ),
    },
    {
      field: "severity_name",
      headerName: "Severity",
      width: 150,
      renderCell: (params) =>
        params.value ? (
          <Box sx={{ color: params.row.severity_colour || "black" }}>
            {params.value}
          </Box>
        ) : (
          "-"
        ),
    },
    {
      field: "created_by",  // this field is require
      headerName: "Created By",
      width: 180,
      renderCell: (params) => params.value || "",
    },
    {
      field: "added_at",
      headerName: "Created At",
      width: 180,
      renderCell: (params) => {
        if (!params.value) return "-";
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 180,
      renderCell: (params) => {
        if (!params.value) return "-";
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
    {
      field: "updated_name",
      headerName: "Updated By",
      width: 180,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.updated_name || params.row.updatedBy_name || "-"}
          </Box>
        );
      },
    },
  ];
  const [expandedRows, setExpandedRows] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  // const [selectedTask, setSelectedTask] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editData, setEditData] = useState(null);
  const [filter, setFilter] = useState(1);
  const [MilestoneIssues, setMilestoneIssues] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const { project_id, id: milestone_id } = useParams();
  const [filterValue, setFilterValue] = useState(false);
  const [viewMode, setViewMode] = useState("table");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  // const [isFilterVisible, setIsFilterVisible] = useState(false);
  const navigate = useNavigate();
  // console.log("project_id:", project_id, milestone_id);

  const { id } = useParams();
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  ////console.log()("login_user_detail in redux state: ", loginUser);
  const { role: login_user_role } = loginUser;
  const { refetch: refetch_milestone_issues } = useFetchMilestoneIssuesQuery(id);
  const fetchSearchedMilestoneIssue = async (searchQuery) => {
    // setLoading(true);
    try {
      const response = await newFilterEntities("milestones/issue/show", id, {
        // search: searchQuery,
        search: searchQuery.trim(),
      });
      if (response) {
        setMilestoneIssues(response.issues);
      } 
      else {
        setMilestoneIssues([]);
      }
    } 
    catch (error) {
      console.error("Failed to fetch projects:", error);
      setMilestoneIssues([]);
      // Handle the error appropriately in the caller
    // } finally {
    //   setLoading(false);
    }
  };

  const fetchMilestoneIssues = async () => {
    setLoading(true);
    const requestedData = {
      view_type_id: filter,
    };

    try {
      const response = await newFilterEntities( "milestones/issue/show", id, requestedData);
      setFilterValue(false);

      ////console.log()(response, "fetchMilestoneIssues");
      if (response?.issues) {
        const data = response.issues;
        ////console.log()(data, "Mapped Issues Data");
        setMilestoneIssues(data);
      } 
      else {
        console.error("No issues found in the response.");
      }
      refetch_milestone_issues();
    }
     catch (error) {
      console.error("Error fetching issues:", error);
    } 
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMilestoneIssues();
  }, [filter, viewMode]);

  const handleShowFilter = () => setShowFilter(true); // Open filter
  const handleShowProject = () => setShowProject(true); // Open filter

  const toggleExpandRow = (taskId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };

  const handleMenuClick = (event, row) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = (event) => {
    if (event) event.stopPropagation();
    setMenuAnchorEl(null);
  };

  const handleEditIssue = (event) => {
    event.stopPropagation();
    const issueId = selectedRow?.issue_id;
    const mid = selectedRow?.milestone_id || milestone_id;
    const pid = selectedRow?.project_id || project_id || localStorage.getItem("project_id");
    if (issueId) {
      navigate(`/projects/projectDetail/${pid}/milestone/MilestoneDetail/${mid}/MilestoneIssueDetail/${issueId}`);
    }
    handleMenuClose();
  };

  const handleViewInNewTab = (event) => {
    event.stopPropagation();
    const issueId = selectedRow?.issue_id;
    const mid = selectedRow?.milestone_id || milestone_id;
    const pid = selectedRow?.project_id || project_id || localStorage.getItem("project_id");
    if (issueId) {
      const path = `/projects/projectDetail/${pid}/milestone/MilestoneDetail/${mid}/MilestoneIssueDetail/${issueId}`;
      openInNewTab(path);
    }
    handleMenuClose();
  };



  const filterOptions = {
    predefined: [
      { label: "All Issue", value: 1 },
      { label: "All Open", value: 2 },
      { label: "All Closed", value: 3 },
      { label: "All Overdue & Open", value: 4 },
      { label: "Unassigned Issue", value: 5 },
    ],
    myViews: [
      { label: "My Open", value: 6 },
      { label: "My Closed", value: 7 },
      { label: "Today's Issue", value: 8 },
      { label: "Issue I Follow", value: 9 },
      { label: "Issue  Created By Me", value: 10 },
    ],
  };

  const handleFilterChange = (event) => {
    const value = event.target.value;
    setFilter(value);

    let filteredProjects;
    switch (value) {
      case "completed":
        filteredProjects = MilestoneIssues.filter(
          (project) => project.completion === 100
        );
        break;
      case "recent":
        filteredProjects = MilestoneIssues;
        break;
      default:
        filteredProjects = MilestoneIssues;
    }

    setMilestoneIssues(filteredProjects);
  };

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value) {
      await fetchSearchedMilestoneIssue(value);
    } else {
      await fetchMilestoneIssues();
    }
  };

  const handleApplyFilter = (oldData) => {
    setMilestoneIssues(
      oldData.map((datas) => ({
        ...datas,
        id: datas.issue_id, // Ensure DataGrid has a unique ID
      }))
    );
    setShowFilter(false);
    setFilterValue(true);
  };

  const handleClearFilter = () => {
    setFilteredData([]); // Reset the grid data
  };
  const handleCancelFilter = () => {
    // setIsFilterVisible(false); // Hide filter component
    setShowFilter(false);
  };

  // Handle row click
  const handleRowClick = (params) => {
    const { issue_id } = params.row;
    navigate(`/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${params.row.milestone_id}/MilestoneIssueDetail/${issue_id}`);
  };

  const handleClearAllFilters = () => {
    fetchMilestoneIssues();
    sessionStorage.setItem("isIssueFilterApplied", false);
    sessionStorage.removeItem("issue_filter_data");
  };

  useEffect(() => {
    sessionStorage.setItem("isIssueFilterApplied", false);
    sessionStorage.removeItem("issue_filter_data");
  }, []);

  return (
    <>
      {/* Add  Project */}
      <Offcanvas
        show={showProject}
        onHide={() => {
          setShowProject(false);
          setEditData(null);
        }}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          {/* <AddMilestoneIssueComponent
            onCancel={() => setShowProject(false)}
            fetchMilestoneIssues={fetchMilestoneIssues}
          /> */}
          <CommonAddIssue
            onClear={() => reset()} // Resets to initial values
            onCancel={() => {
              setShowProject(false);
              setEditData(null);
            }}
            // Issues={Issues}
            fetchIssues={fetchMilestoneIssues}
            path="milestones/issue"
            taskId={milestone_id}
            project_id={project_id}
            isTaskDetail={true}
            editData={editData}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      {/* Add filter */}
      <Offcanvas
        show={showFilter}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          {/* <MilestoneIssueFilterComponent
            onApply={handleApplyFilter}
            onClear={handleClearFilter}
            onCancel={handleCancelFilter}
          /> */}
          <IssueFilterComponent
            // onApply={handleApplyFilter}
            // onClear={handleClearFilter}
            // onCancel={() => setShowFilter(false)}
            filter_path="milestones/issue/filter"
            onApply={handleApplyFilter}
            // filter_id={project_id}
            isMilestone={true}
            milestone_id={milestone_id}
            refetch_list={fetchMilestoneIssues}
            onClear={handleClearFilter} // Resets to initial values
            onCancel={handleCancelFilter}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <div className="py-3">
        {/* <div className="d-flex justify-content-between pb-2"> */}
        <Box
          className="d-flex justify-content-between"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "16px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
          }}
        >
          <div className="d-flex align-items-center">
            <FormControl className="">
              <Select value={filter} onChange={handleFilterChange} displayEmpty size="small">
                <ListSubheader className="ps-3 text-rgba-gray">Predefined Views</ListSubheader>
                {filterOptions.predefined.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
                <ListSubheader className="ps-3 text-rgba-gray">My Views</ListSubheader>
                {filterOptions.myViews.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div className="d-flex align-items-center d-none d-sm-flex">
              <Tooltip title="Table View">
                <Button
                  onClick={() => setViewMode("table")}
                  sx={{
                    backgroundColor: viewMode === "table" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "table" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "table" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    minWidth: "75px",
                    padding: "0 10px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    marginRight: '10px',
                    textTransform: "none",
                    marginBottom:"1px",
                    marginLeft:"11px",
                    "&:hover": {
                      backgroundColor: viewMode === "table" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <CiViewList size={18} />
                  Table
                </Button>
              </Tooltip>
              <Tooltip title="Board View">
                <Button
                  onClick={() => setViewMode("board")}
                  sx={{
                    backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    minWidth: "75px",
                    padding: "0 10px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    textTransform: "none",
                    marginBottom:"1px",
                    "&:hover": {
                      backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <MdViewQuilt size={18} />
                  Board
                </Button>
              </Tooltip>
            </div>
          </div>

          <div className="d-flex align-items-center">
            <SearchBar
              placeholder="Search issues"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />
            {filterValue && (
              <button
                className=" addmore_btn"
                onClick={handleClearAllFilters}
                disabled={loading}
              >
                Clear Filter
              </button>
            )}

            {login_user_role !== "CLIENT" && (
              <Tooltip title="Add Issue">
                <IconButton
                  className="ms-3"
                  onClick={handleShowProject}
                  sx={{
                    // color: "rgba(18, 183, 159, 1)",
                      backgroundColor: isDarkMode
                      ? "rgba(67, 105, 255, 0.08)"
                      : "#F1F5FF",
                    borderRadius: "50%",
                    margin: "0 10px 0 12px",
                    width: "39px",
                    height:"39px",
                    "&:hover": {
                      backgroundColor: "var(--icon-hover-bg)",
                    },
                    me: 2,
                  }}
                >
                  <CiCirclePlus className="pro-icon-s text-rgbr-blue" />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title="Filter">
              <IconButton
                className="ms-3"
                onClick={handleShowFilter}
                sx={{
                  // color: "rgba(18, 183, 159, 1)",
                     backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  borderRadius: "50%",
                  margin: "0 10px 0 12px",
                  width: "39px",
                  height: "39px",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                  me: 2,
                }}
              >
                <CiFilter className="pro-icon-s text-rgbr-blue" />
              </IconButton>
            </Tooltip>
          </div>
        {/* </div> */}
        </Box>
        {loading ? (
          <Loader /> // Display loader while loading
        ) : (
          <Box style={{ width: "100%" }}>
            {viewMode === "table" ? (
              <div className="row">
                <div className="col-12 ">
                  <FilterSummaryBox
                    onApply={handleApplyFilter}
                    status_type="ISSUE"
                    task_filter_id={project_id}
                    // filter_path="/project/filter"
                    filter_path="milestones/issue/filter"
                    has_view_type={true}
                  />
                </div>
                <Box
                  sx={{ height: MilestoneIssues?.length === 0 ? 300 : "100%" }}
                >
                  <DataGrid
                    rows={MilestoneIssues}
                    columns={columns}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10, 20, 30, 40]}
                    slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                    onRowClick={handleRowClick}
                    getRowId={(row) => row.issue_id}
                    disableSelectionOnClick
                  />
                </Box>
              </div>
            ) : (
              <IssueBoard
                ProjectID={project_id || localStorage.getItem("project_id")}
                allIssues={(MilestoneIssues || []).map(i => ({
                  ...i,
                  id: i.id || i.issue_id
                }))}
                onRefresh={fetchMilestoneIssues}
                loading={loading}
                onOpenIssue={(issue) => {
                  const pid = issue.project_id || project_id || localStorage.getItem("project_id");
                  const mid = issue.milestone_id || milestone_id;
                  const isid = issue.id || issue.issue_id;
                  navigate(`/projects/projectDetail/${pid}/milestone/MilestoneDetail/${mid}/MilestoneIssueDetail/${isid}`);
                }}
              />
            )}

            {/* Menu for Action Button Options */}
            <Menu
              anchorEl={menuAnchorEl}
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
              onClick={(e) => e.stopPropagation()}
            >
              <MenuItem onClick={handleEditIssue}>
                <EditIcon fontSize="small" className="me-2 text-primary" />
                Edit Issue
              </MenuItem>
              <MenuItem onClick={handleViewInNewTab}>
                <CiViewList className="me-2" color="blue" size={17} />
                View in New Tab
              </MenuItem>
              {selectedRow?.issue_id && (
                <CommonDeleteDialog
                  name="Issue"
                  statusName={selectedRow?.title}
                  url="issue/delete"
                  id={selectedRow?.issue_id}
                  refetchList={fetchMilestoneIssues}
                  handleListClose={handleMenuClose}
                />
              )}
            </Menu>
          </Box>
        )}
      </div>
    </>
  );
};

export default MilestoneIssue;
